import { FANOUT_PAGES, PAGES } from './site';

export const GUIDE_GROUPS = [
  {
    id: 'aplicar',
    title: 'Aplicar corretamente',
    description: 'Prepare a aplicação, preserve a padronização e reconheça situações que mudam a comparabilidade.',
    paths: [
      '/como-aplicar',
      '/erros-de-aplicacao',
      '/adaptacoes-sensoriais',
      '/quem-pode-aplicar',
      '/mini-mental-telessaude',
      '/formulario-e-direitos-de-uso'
    ]
  },
  {
    id: 'interpretar',
    title: 'Interpretar o resultado',
    description: 'Escolha a referência adequada e entenda o que um escore pode — e não pode — concluir.',
    paths: [
      '/interpretacao-dos-resultados',
      '/escolaridade',
      '/pontos-de-corte',
      '/diagnostica-alzheimer',
      '/meem-incompleto'
    ]
  },
  {
    id: 'acompanhar',
    title: 'Acompanhar ao longo do tempo',
    description: 'Entenda mudança de pontuação, variabilidade teste-reteste e comparabilidade entre aplicações.',
    paths: ['/acompanhamento-e-queda-de-pontos']
  },
  {
    id: 'escolher-instrumentos',
    title: 'Escolher ou combinar instrumentos',
    description: 'Compare o MEEM com outros instrumentos e saiba quando uma medida complementar acrescenta informação.',
    paths: ['/mini-mental-ou-moca', '/mini-mental-e-teste-do-relogio']
  }
];

export const GUIDE_RELATED = {
  '/como-aplicar': ['/erros-de-aplicacao', '/adaptacoes-sensoriais', '/mini-mental-telessaude', '/formulario-e-direitos-de-uso'],
  '/mini-mental-telessaude': ['/como-aplicar', '/formulario-e-direitos-de-uso', '/interpretacao-dos-resultados', '/erros-de-aplicacao'],
  '/erros-de-aplicacao': ['/como-aplicar', '/adaptacoes-sensoriais', '/acompanhamento-e-queda-de-pontos', '/meem-incompleto'],
  '/adaptacoes-sensoriais': ['/como-aplicar', '/erros-de-aplicacao', '/interpretacao-dos-resultados'],
  '/quem-pode-aplicar': ['/como-aplicar', '/formulario-e-direitos-de-uso', '/erros-de-aplicacao'],
  '/formulario-e-direitos-de-uso': ['/como-aplicar', '/quem-pode-aplicar', '/erros-de-aplicacao'],
  '/interpretacao-dos-resultados': ['/pontos-de-corte', '/escolaridade', '/diagnostica-alzheimer', '/acompanhamento-e-queda-de-pontos', '/meem-incompleto'],
  '/escolaridade': ['/pontos-de-corte', '/interpretacao-dos-resultados', '/mini-mental-ou-moca'],
  '/pontos-de-corte': ['/escolaridade', '/interpretacao-dos-resultados', '/diagnostica-alzheimer'],
  '/diagnostica-alzheimer': ['/interpretacao-dos-resultados', '/pontos-de-corte', '/mini-mental-ou-moca'],
  '/acompanhamento-e-queda-de-pontos': ['/interpretacao-dos-resultados', '/erros-de-aplicacao', '/diagnostica-alzheimer'],
  '/meem-incompleto': ['/interpretacao-dos-resultados', '/como-aplicar', '/erros-de-aplicacao', '/acompanhamento-e-queda-de-pontos'],
  '/mini-mental-ou-moca': ['/interpretacao-dos-resultados', '/diagnostica-alzheimer', '/mini-mental-e-teste-do-relogio'],
  '/mini-mental-e-teste-do-relogio': ['/mini-mental-ou-moca', '/interpretacao-dos-resultados', '/como-aplicar']
};

const CLINICAL_PAGES = [...PAGES, ...FANOUT_PAGES];

export function getGuideGroupForPath(path) {
  return GUIDE_GROUPS.find((group) => group.paths.includes(path));
}

export function getGuideRelated(path) {
  return GUIDE_RELATED[path] || [];
}

export function getGuidePage(path) {
  return CLINICAL_PAGES.find((page) => page.path === path);
}
